export { default } from './DatePicker';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-date-picker/es/index.js
// module id = 290
// module chunks = 0